import { render, staticRenderFns } from "./WeblinksCard.vue?vue&type=template&id=42767eb8&scoped=true&"
import script from "./WeblinksCard.vue?vue&type=script&lang=ts&"
export * from "./WeblinksCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42767eb8",
  null
  
)

export default component.exports